import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import ReactDOM from "react-dom";
import { QRCodeSVG } from "qrcode.react";
import { useEffect, useState } from "react";
import API from "../Api";

let serverUrl = window.location.origin;

export default function SelectWallet() {
  const notify = (err: any) => toast.error(err, { theme: "colored" });
  const notifySuccess = (text: any) =>
    toast.success(text, { theme: "colored" });
  const navigate = useNavigate();

  const [searchParams, setSearchParams] = useSearchParams({});
  const [qrCode, setQrCode] = useState("https://issuer.mynext.id/");
  const [walletLink, setWalletLink] = useState("https://wallet.mynext.id/");

  useEffect(() => {
    let brandID = searchParams.get("brandId");

    API(
      "/api/v1/brand/" +
        (brandID == "" ? "root" : brandID) +
        "/offer?id=" +
        searchParams.get("id") +
        "&type=create_urls"
    )
      .then((response) => {
        setQrCode(response.qr);
        setWalletLink(response.url);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  //let qrCodeLink = "https://issuer.mynext.id/";

  const mynextid_wallet = () => {
    window.open(walletLink);
  };

  return (
    <>
      <div className="mobile-pro">
        <div className="login">
          <img src="img/issue-icon-default.svg" />
          <h2>Choose wallet</h2>
        </div>
      </div>

      <div className="col-content">
        <div className="notifications-container">
          <div className="messages no-mobile-pro">
            <h2>Choose wallet</h2>
          </div>

          <div className="cards cards-3">
            <div>
              <div className="qr_code_wallet">
                <div style={{ textAlign: "center" }}>
                  <QRCodeSVG value={qrCode} height="200" width="200" />
                </div>

                <div className="divider">OR</div>
              </div>

              <button
                className="form-submit-btn btn btn-primary"
                key="submit"
                type="submit"
                value="Submit"
                onClick={() => {
                  mynextid_wallet();
                }}
              >
                MyNextId wallet
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
